<template>
  <DashboardTopCardContent
    :callToActionButtonText="$t('L_learn_more')"
    @callToActionCallback="goToLearnMoreDS"
  >
    <template #main-content>
      <h2 class="text-h2 font-weight-bold text-center">
        {{ $t('L_a_faster_simpler_path_to') }}
      </h2>
      <h4 class="text-center font-weight-medium">
        {{ $t('L_donot_let_debt_keep') }}
      </h4>
    </template>
  </DashboardTopCardContent>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import DashboardTopCardContent from '../../DashboardTopCardContent.vue';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'DebtSolutionsNoPlanTop',
  components: { DashboardTopCardContent },
  methods: {
    goToLearnMoreDS() {
      if (this.$route.path !== '/debtsolutions/learnmoredebt') {
        this.$router.push({ name: RouteNames.LEARN_MORE_DEBT });
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>
